/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Clear_Descriptions_ConfirmInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to clear all marker descriptions?" |
*
* @param {Markers_Clear_Descriptions_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_clear_descriptions_confirm = /** @type {((inputs?: Markers_Clear_Descriptions_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Clear_Descriptions_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voulez-vous vraiment effacer toutes les descriptions de marqueurs ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie wirklich alle Markierungsbeschreibungen löschen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vuoi davvero cancellare tutte le descrizioni dei marcatori?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы уверены, что хотите удалить все описания маркеров?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Está seguro de que desea borrar todas las descripciones de marcadores?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您确定要清除所有标记描述吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのマーカーの説明をクリアしてもよろしいですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वाकई सभी मार्कर विवरणों को हटाना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tem certeza de que deseja apagar todas as descrições dos marcadores?")
	return /** @type {LocalizedString} */ ("Are you sure you want to clear all marker descriptions?")
});